import { render, staticRenderFns } from "./DialogConsentGeneralOnechatCreate.vue?vue&type=template&id=aa7ae526&scoped=true&"
import script from "./DialogConsentGeneralOnechatCreate.vue?vue&type=script&lang=js&"
export * from "./DialogConsentGeneralOnechatCreate.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentGeneralOnechatCreate.vue?vue&type=style&index=0&id=aa7ae526&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7ae526",
  null
  
)

export default component.exports